module.exports = __webpack_public_path__ + "static/DJS0-fa158ea16fa1f9d70aef3a28e31762ec.png";